import {inject, injectable} from 'inversify';

import {logger} from '../../../utils/logger';
import {FetchUserWaitlistItemsQuery} from '../../ports/User/FetchUserWaitlistItems/FetchUserWaitlistItems.query';

@injectable()
export class FetchUserWaitlistItemsUseCase {
  constructor(
    @inject(FetchUserWaitlistItemsQuery)
    private query: FetchUserWaitlistItemsQuery,
  ) {}

  execute(
    props?: FetchUserWaitlistItemsUseCase.Props,
  ): Promise<FetchUserWaitlistItemsUseCase.Response> {
    try {
      return this.query.fetch(props);
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}

export namespace FetchUserWaitlistItemsUseCase {
  export type Props = FetchUserWaitlistItemsQuery.Props;
  export type Response = FetchUserWaitlistItemsQuery.Response;
}
